<script>
import Zetrix from "../../utils/zetrix";
import ButtonOutline from "../buttons/buttonOutline.vue";
import notificationSound from "../../assets/sounds/notification.mp3";
import DialogNotification from "../dialogs/dialogNotification.vue";

export default {
  components: {
    ButtonOutline,
    DialogNotification,
  },
  mixins: [Zetrix],
  props: {
    noti: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      showDialogAccount: false,
      position: "center",
      duration: 1500,
      isCopied: false,
      pending: sessionStorage.getItem("notification"),
      receivedNoti: false,
      buttonName: "Connect Wallet",
      iconPlacement: "prepend",
      buttonIcon: "mdi-wallet-outline",
      snackbar: false,
      showDialogNotification: false,
      isJointExist: false,
    };
  },
  mounted() {
    this.checkZetrixAccount();
  },
  computed: {
    convertZtx: function () {
      return this.balance / 1000000 + " ZTX";
    },
    isSmallScreen() {
      return this.$vuetify.display.xs;
    },
  },
  watch: {
    noti(newValue) {
      this.pending = newValue;
      this.receivedNoti = true;
      const audio = new Audio(notificationSound);

      audio.play();
      setTimeout(() => {
        this.receivedNoti = false;
      }, 5000);
    },
    // watch zetrixAccount value
    zetrixAccount() {
      this.checkZetrixAccount();
    },
  },
  created() {
    if (this.zetrixAccount) {
      this.countUnseenNotification();
    }
  },
  methods: {    
    navigate(path) {
      this.$router.push({ name: path });
    },
    customProcess() {
      this.checkZetrixInstall();
    },
    toLoginZetrix() {
      this.checkZetrixInstall();
    },
    toLogoutZetrix() {
      this.showDialogAccount = false;
      this.disconnectWalletZtx();
    },
    handleCopiedEvent(isCopied) {
      this.isCopied = isCopied;
    },
    openNotification() {
      this.showDialogNotification = true;
    },
    onCloseNotification() {
      this.showDialogNotification = false;
    },
    goToNotification() {
      if (this.$route.path === "/notification") {
        window.location.reload();
      } else {
        this.$router.push("/notification");
      }
    },
    countUnseenNotification() {
      this.$store
        .dispatch("notification/countNotification", {
          queryValue:
            "?userAddress=" + this.zetrixAccount + "&seen=false&type=MULTISIG",
        })
        .then((response) => {
          if (response != null) {
            this.pending = response;
            sessionStorage.setItem("notification", this.pending);
          }
        });
    },
    shortenUserName(string) {
      const len = string.length;
      if (len > 10) {
        return string.substr(0, 5) + "..." + string.substr(len - 5, len);
      } else {
        return string;
      }
    },
    shortenAddress(string) {
      const len = string.length;
      if (len > 10) {
        return string.substr(0, 12) + "..." + string.substr(len - 12, len);
      } else {
        return string;
      }
    },
    copyAddress(text) {
      navigator.clipboard.writeText(text);
      this.snackbar = true;
    },
    async checkZetrixAccount() {
      if (this.zetrixAccount !== null && this.zetrixAccount !== "") {
        await this.getJointAddresses()
      }
    },
    async getJointAddresses() {
      await this.$store
        .dispatch("multisig/getJointAddressList", {
          zetrixAccount: this.zetrixAccount
        })
        .then((response) => {
          if (response !== null) {
            this.isJointExist = true
            return true
          } else {
            return false
          }
        })
        .catch((error) => {
          console.error("Error fetching joint addresses:", error);
          return false
        });
    },
    checkJointIsExist() {
      if (this.isJointExist) {
        this.navigate('dashboard')
      } else {
        this.navigate('index')
      }
    },
  },
  name: "NavBar",
};
</script>

<template>
  <v-app-bar :elevation="1" color="white">
    <v-app-bar-title>
      <v-img :width="isSmallScreen ? '128' : '150'" aspect-ratio="16/9" cover src="../../assets/images/Zetrix-Logo-small-black.png"
        class="responsive-img" @click="checkJointIsExist"></v-img>
    </v-app-bar-title>
    <!-- <v-btn
      v-if="zetrixAccount !== null"
      density="default"
      icon="mdi-bell-outline"
      class="primary"
      size="small"
      @click="openNotification"
    ></v-btn> -->
    <v-icon v-if="zetrixAccount !== null" class="notification-icon primary" size="small" @click="openNotification">
      mdi-bell-outline
    </v-icon>
    <div class="nav-spacer"></div>
    <ButtonOutline
      v-if="zetrixAccount !== null"
      button-height="40"
      :button-width="isSmallScreen ? '160' : '180'"
      :button-name="this.shortenUserName(zetrixAccount)"
      :icon-placement="iconPlacement"
      :button-icon="buttonIcon"
      icon-type="image"
      @click="showDialogAccount = true"
    />
    <ButtonOutline
      v-else
      button-height="40"
      :button-name="buttonName"
      :icon-placement="iconPlacement"
      :button-icon="buttonIcon"
      icon-type="icon"
      @customProcess="customProcess"
    />
    <div class="nav-spacer"></div>
    <div class="nav-spacer"></div>
  </v-app-bar>

  <!-- Start Disconnect Dialog -->
  <v-dialog v-model="showDialogAccount" width="350">
    <v-card>
      <v-card-text>
        Your connected wallet address
        <br />
        <b>{{ shortenAddress(zetrixAccount) }}
          <v-icon class="ml-2" @click="copyAddress(zetrixAccount)">
            mdi-content-copy
          </v-icon></b>
        <br />
        <div class="spacer"></div>
        <div class="d-flex dialog-balance">
          <span>Wallet balance</span>
          <b>{{ balance / 1000000 }} ZETRIX</b>
        </div>
        <v-card-actions class="justify-center">
          <ButtonOutline
            button-width="290"
            class="disconnect-btn"
            button-icon="mdi-power"
            icon-type="icon"
            icon-placement="prepend"
            button-name="Disconnect"
            button-size="large"
            @click="toLogoutZetrix"
          />
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- End Disconnect Dialog -->

  <!-- Start Notification Dialog -->
  <DialogNotification
    class="notification-dialog"
    @closeNotification="onCloseNotification"
    v-model:showDialogNotification="showDialogNotification"
  />
  <!-- End Notification Dialog -->

  <v-snackbar v-model="snackbar" :timeout="2000" :max-width="50">
    Address copied!
  </v-snackbar>
</template>

<style>
.nav-spacer {
  padding-right: 10px;
}

.responsive-img {
  max-width: 100%;
  height: auto;
  cursor: pointer;
}

.v-dialog>.v-overlay__content>.v-card>.v-card-text,
.v-dialog>.v-overlay__content>form>.v-card>.v-card-text {
  padding: 16px 24px 16px 24px;
}

.dialog-balance {
  justify-content: space-between;
}

.disconnect-btn {
  width: 280px;
}

.notification-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.notification-dialog {
  padding-top: 40px;
  display: flex;
  justify-content: end;
  align-items: start;
}
</style>
